import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { DeviceEffects } from './device.effects';
import { DEVICE_FEATURE_KEY, deviceReducer } from './device.reducer';

export const provideDeviceStore = () => [
  provideState(DEVICE_FEATURE_KEY, deviceReducer),
  provideEffects([DeviceEffects]),
];
